import {
    Box,
    HStack,
    IconButton,
    Separator,
    Text,
    VStack,
} from "@chakra-ui/react";

import {
    Copy,
    Share2,
    FingerprintPattern
} from "lucide-react";
import { toaster } from "../../../components/toaster";
import ActivityToast from "../../../components/ActivityToast";
import Card from "../../Dashboard/components/Card";

const ReferralCard = ({
    driverPartner,
    totalRecruits = 0,
    totalEarned = 0,
}) => {
    const referralCode =
        driverPartner?.partner_referral_code ||
        "-";

    const referralLink =
        driverPartner?.partner_referral_link ||
        `https://mogoma.co.bw/partner/${referralCode}`;

   const handleCopyCode =
    async () => {
        await navigator.clipboard.writeText(
            referralCode
        );

        toaster.create({
            render: () => (
                <ActivityToast
                    type="success"
                    title="Referral Code Copied"
                    description="Your referral code has been copied to the clipboard."
                    timestamp="Just now"
                />
            ),
        });
    };

const handleShareLink =
    async () => {
        try {
            if (
                navigator.share
            ) {
                await navigator.share(
                    {
                        title:
                            "Join Mogoma",
                        text: `Join Mogoma using my referral code ${referralCode}`,
                        url: referralLink,
                    }
                );

                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="Referral Shared"
                            description="Your referral invitation was shared successfully."
                            timestamp="Just now"
                        />
                    ),
                });
            } else {
                await navigator.clipboard.writeText(
                    referralLink
                );

                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="Referral Link Copied"
                            description="Your referral link has been copied to the clipboard."
                            timestamp="Just now"
                        />
                    ),
                });
            }
        } catch (
            error
        ) {
            console.error(
                error
            );
        }
    };

    return (
        <Card
            bg="#2453FF"
            color="white"
            borderRadius="24px"
            p={6}
            overflow="hidden"
        >
            <Text
                fontSize="2xl"
                fontWeight="700"
                mb={2}
            >
                Recruit & Earn
            </Text>

            <Text
                fontSize="sm"
                lineHeight="1.7"
                opacity={0.9}
                mb={8}
            >
                Invite drivers to
                join Mogoma and
                earn commission
                rewards as they
                achieve referral
                milestones.
            </Text>

            {/* Referral Code */}

            <Text
                fontSize="10px"
                letterSpacing="0.15em"
                textTransform="uppercase"
                opacity={0.7}
                mb={2}
            >
                Your Referral Code
            </Text>

            <HStack
                mb={6}
                align="stretch"
            >
                <Box
                flex="1"
                minW={0}
                bg="rgba(255,255,255,.10)"
                border="1px solid rgba(255,255,255,.18)"
                borderRadius="14px"
                px={4}
                py={3}
            >
                <HStack
                    justify="center"
                    gap={3}
                >
                    <FingerprintPattern
                        size={20}
                        opacity={0.9}
                    />

                    <Text
                        fontSize="lg"
                        fontWeight="700"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                    >
                        {referralCode}
                    </Text>
                </HStack>
            </Box>

                <IconButton
                    aria-label="Copy code"
                    bg="white"
                    color="#2453FF"
                    borderRadius="14px"
                    onClick={
                        handleCopyCode
                    }
                    _hover={{
                        bg: "gray.100",
                    }}
                >
                    <Copy size={18} />
                </IconButton>
            </HStack>

            {/* How it Works */}

            <Text
                fontSize="10px"
                letterSpacing="0.15em"
                textTransform="uppercase"
                opacity={0.7}
                mb={2}
            >
               How it Works
            </Text>

             <VStack
    align="start"
    gap={3}
    mb={2}
>
    <HStack align="start">
        <Text
            fontWeight="700"
            opacity={0.9}
        >
            1.
        </Text>

        <Text
            fontSize="sm"
            opacity={0.9}
            lineHeight="1.6"
        >
            Register a new driver account directly from your partner dashboard.
        </Text>
    </HStack>

    <HStack align="start">
        <Text
            fontWeight="700"
            opacity={0.9}
        >
            2.
        </Text>

        <Text
            fontSize="sm"
            opacity={0.9}
            lineHeight="1.6"
        >
            Upload driver and vehicle documents to complete onboarding faster.
        </Text>
    </HStack>

    <HStack align="start">
        <Text
            fontWeight="700"
            opacity={0.9}
        >
            3.
        </Text>

        <Text
            fontSize="sm"
            opacity={0.9}
            lineHeight="1.6"
        >
            Referral tracking is linked automatically and commissions are earned as milestones are achieved.
        </Text>
    </HStack>
</VStack>

            <Separator
                my={6}
                borderColor="rgba(255,255,255,.18)"
            />

            {/* Stats */}

            <HStack
                justify="space-between"
                align="flex-start"
            >
                <VStack
                    align="start"
                    gap={1}
                >
                    <Text
                        fontSize="10px"
                        textTransform="uppercase"
                        letterSpacing="0.15em"
                        opacity={0.7}
                    >
                        Total Recruits
                    </Text>

                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                    >
                        {totalRecruits}
                    </Text>
                </VStack>

                <VStack
                    align="end"
                    gap={1}
                >
                    <Text
                        fontSize="10px"
                        textTransform="uppercase"
                        letterSpacing="0.15em"
                        opacity={0.7}
                    >
                        Earned
                    </Text>

                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                    >
                        P
                        {totalEarned}
                    </Text>
                </VStack>
            </HStack>
        </Card>
    );
};

export default ReferralCard;